import { Typography } from "@mui/material";
import React from "react";
import DocumentSidebar from "../DocumentSidebar";

type Props = {
  onVersionsClick: () => void;
};

const DocumentSignaturesSidebar = ({ onVersionsClick }: Props) => {
  return (
    <DocumentSidebar onVersionsClick={onVersionsClick}>
      <Typography variant="body1">
        This view includes signature blocks that have been signed.
      </Typography>
    </DocumentSidebar>
  );
};

export default DocumentSignaturesSidebar;
